<div
  [ngClass]="{ 'no-row-limit-gallery flex-grid': !config.limitToOneRow }"
  #thumbContainer
  class="gallery-thumbnails-container flex flex-row"
  data-test-id="gallery-thumbnails-container"
>
  @for (thumb of visibleItems | slice: 0 : limitTo; track thumb.Id; let i = $index) {
    <sharepoint-gallery-thumb
      [config]="config"
      [ngClass]="{
        'no-row-limit-gallery-item': !config.limitToOneRow,
        firstItem: i === 0,
        lastItem: config.limitToOneRow && i + 1 === config.rowItems,
      }"
      [ngStyle]="{
        height: getThumbHeight(),
        width: getThumbWidth(),
      }"
      [thumbItem]="thumb"
      (click)="showPreview(i)"
      class="gallery-thumb flex flex-center-center"
    ></sharepoint-gallery-thumb>
  }
  @if (config.limitToOneRow && items.length > config.rowItems) {
    <div
      [ngStyle]="{
        height: getThumbHeight(),
        width: getThumbWidth(),
      }"
      (click)="$event.stopPropagation()"
      class="show-all-layer"
      data-test-id="show-all-layer"
    >
      <a [routerLink]="['/content/news/', newsId]" class="flex flex-[1_0_auto] flex-center-center w-full h-full">
        <div class="thumb-content">
          <div class="images-count typography-top-header" data-test-id="images-count">
            +{{ items.length - limitTo }}
          </div>
          <p class="typography-label font-bold text-12 leading-17">
            Show all
            <span class="max-md:hidden">photos</span>
          </p>
        </div>
      </a>
    </div>
  }
</div>
@if (!config?.limitToOneRow) {
  <div>
    <div
      [isTargetElement]="true"
      (elementVisible)="loadMore$.next($event)"
      id="visible-gallery-end"
      isElementVisible
    ></div>
  </div>
}
